module.exports = __webpack_public_path__ + "static/img/q1.e220ec85.jpg";